import { createRoot } from "react-dom/client";
import App from "./App.jsx";
import "./index.css";
import { AppProvider } from "@/context/AppContext";
import { Provider } from "react-redux";
import store from "./Redux/Store/store.js";
import { AuthProvider } from "@/context/AuthContext.jsx";
import axios from "axios";
import { logoutUser } from "./Redux/ReduxSlices/authSlice.js";
import { HelmetProvider } from "react-helmet-async";

axios.interceptors.response.use(
  (response) => response,
  (error) => {
    const status = error?.response?.status;
    if (status === 401) {
      try {
        store.dispatch(logoutUser());
      } finally {
        window.location.assign("/");
      }
    }
    return Promise.reject(error);
  },
);

createRoot(document.getElementById("root")).render(
  <Provider store={store}>
    <AuthProvider>
      <AppProvider>
        <HelmetProvider>
          <App />
        </HelmetProvider>
      </AppProvider>
    </AuthProvider>
  </Provider>,
);
